module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }